import L from 'leaflet';
import 'leaflet.motion/dist/leaflet.motion.js';
import isEmpty from 'lodash/isEmpty';

import { getPoints, isSameLatLng } from '../util';

const WindMixin = {
  props: {
    // 轨迹动画数据
    motions: {
      type: Array,
      default: () => []
    }
  },
  mounted() {
    if (!this.renderFuncs) this.renderFuncs = [];
    this.renderFuncs.push(this.syncMotions);
  },
  watch: {
    motions() {
      this.syncMotions();
    }
  },
  methods: {
    findShapeIndex(data) {
      return this.motionShapes.findIndex(s => s.data === data);
    },
    syncMotions() {
      if (!this.motionShapes) {
        this.motionShapes = [];
      }
      const { motions, motionShapes } = this;
      const shapes = [];
      motions.forEach(data => {
        const index = this.findShapeIndex(data);
        if (index === -1) {
          shapes.push(this.createMotion(data));
        } else {
          if (
            !isSameLatLng(data.data, motionShapes[index].motion._linePoints)
          ) {
            this.removeMotion(motionShapes[index]);
            motionShapes[index] = this.createMotion(data);
          } else {
            if (data.auto !== motionShapes[index].auto) {
              if (data.auto) {
                motionShapes[index].motion.motionStart();
                motionShapes[index].motion.intensionIndex = 0;
              } else {
                motionShapes[index].motion.motionStop();
              }
              motionShapes[index].auto = data.auto;
            }
            if (data.pause !== motionShapes[index].pause) {
              if (data.pause) {
                motionShapes[index].motion.motionPause();
              } else {
                motionShapes[index].motion.motionResume();
              }
              motionShapes[index].pause = data.pause;
            }
          }
          shapes.push(motionShapes[index]);
          motionShapes.splice(index, 1);
        }
      });
      motionShapes.forEach(r => this.removeMotion(r));
      this.motionShapes = shapes;
    },
    createMotion(motionData) {
      const { data: motions, auto } = motionData;
      const lines = motions.reduce((acc, m, i) => {
        if (i === motions.length - 1) return acc;
        acc.push(
          L.polyline([m, motions[i + 1]], { color: m.color }).addTo(this.map)
        );
        return acc;
      }, []);
      const motion = L.motion
        .polyline(
          motions.map(m => [m.lat, m.lng]),
          { color: '' },
          {
            auto: true,
            duration: 10000
            // easing: L.Motion.Ease.easeInOutQuart
          },
          {
            removeOnEnd: false,
            // showMarker: true,
            icon: L.icon({
              // todo: 先直接使用台风网图标，后续看情况替换
              iconUrl: 'http://typhoon.nmc.cn/images/tf1.gif',
              iconSize: [24, 24]
            })
          }
        )
        .addTo(this.map)
        .on(L.Motion.Event.Ended, () => {
          const index = this.findShapeIndex(motionData);
          if (index !== -1) {
            this.motionShapes[index].auto = false;
          }
          this.$emit('motionend', motionData);
        });

      let intensions = [];
      if (motions[0].intensions) {
        motion.intensionIndex = 0;
        motion.getMarker().on('move', e => {
          const { latlng } = e;
          if (motion.intensionIndex < motions.length - 1) {
            const preDistance = latlng.distanceTo(
              motions[motion.intensionIndex]
            );
            const postDistance = latlng.distanceTo(
              motions[motion.intensionIndex + 1]
            );
            if (postDistance <= preDistance) {
              motion.intensionIndex += 1;
            }
          }
          this.syncIntensions(
            intensions,
            motions[motion.intensionIndex].intensions,
            latlng
          );
        });
      }

      const circles = motions.map(m => {
        return L.circleMarker(m, {
          radius: 2,
          color: m.color,
          fillOpacity: 1,
          pane: 'markerPane'
        })
          .addTo(this.map)
          .on('mouseover', () => {
            this.$emit('motionover', { point: m, polyline: motions });
          })
          .on('mouseout', () => {
            this.$emit('motionout', { point: m, polyline: motions });
          })
          .on('click', () => {
            motion.motionStop();
            motion
              .getMarker()
              .setLatLng(m)
              .addTo(this.map);
            this.syncIntensions(intensions, m.intensions, m);
          });
      });

      if (!auto) {
        motion.motionStop();
        const endPoint = motions[motions.length - 1];
        motion
          .getMarker()
          .setLatLng(endPoint)
          .addTo(this.map);
        this.syncIntensions(intensions, endPoint.intensions, endPoint);
      }

      return {
        lines,
        circles,
        motion,
        intensions,
        auto,
        data: motionData
      };
    },
    syncIntensions(shapes, intensions, latlng) {
      intensions = intensions || [];
      intensions.forEach((data, i) => {
        if (!shapes[i]) {
          shapes[i] = L.polygon([], {
            fill: '#F4D000',
            color: '#F4D000',
            opacity: 0.3
          }).addTo(this.map);
        }
        shapes[i].setLatLngs(this.getPath(latlng, data));
      });
      if (shapes.length > intensions.length) {
        const removed = shapes.splice(
          intensions.length,
          shapes.length - intensions.length
        );
        removed.forEach(r => r.remove());
      }
    },
    getPath(center, intension) {
      if (isEmpty(intension)) return center;
      var points = [
        ...getPoints([center.lat, center.lng], intension[0], 0, 90, 500),
        ...getPoints([center.lat, center.lng], intension[1], 90, 180, 1000),
        ...getPoints([center.lat, center.lng], intension[2], 180, 270, 1000),
        ...getPoints([center.lat, center.lng], intension[3], 270, 360, 1000)
      ];
      points[points.length] = points[0];
      return points;
    },
    removeMotion(motionShape) {
      if (!motionShape) return;
      const { motion, lines, circles, intensions } = motionShape;
      lines.forEach(l => l.remove());
      circles.forEach(c => c.remove());
      motion.remove();
      intensions.forEach(i => i.remove());
    }
  }
};

export default WindMixin;
